import React from "react"
import type { Dispatch } from "react"
import type { VerEnviosIzzaModel } from "../models/verEnviosIzzaModel"
import { VerEnviosIzzaInicial } from "../models/verEnviosIzzaModel"
import type { VerEnviosIzzaActions } from "./verEnviosIzzaActions"

interface VerEnviosIzzaContextType {
    dados: VerEnviosIzzaModel
    dispatch: Dispatch<VerEnviosIzzaActions>
    erroCarregamento: string | null
}

export const VerEnviosIzzaContext = React.createContext<VerEnviosIzzaContextType>({
    dados: VerEnviosIzzaInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
})
